<template>
  <div class="full-item flex flex-direction align-center justify-center">
    <el-form
      ref="changePwdForm"
      :rules="changePwdRules"
      :model="changePwdForm"
      :label-width="UI.isMobile ? undefined : '80px'"
      style="width: 90%;"
    >
      <el-form-item label="手机号码" prop="mobile">
        <el-input
          placeholder="请输入手机号码"
          clearable
          v-model="changePwdForm.mobile"
        >
          <div slot="suffix" v-if="isSendSms">{{ count }} 秒后重试</div>
          <el-button v-else @click="getCode()" slot="suffix" size="mini">
            获取验证码
          </el-button>
        </el-input>
      </el-form-item>

      <el-form-item label="验证码" prop="sms_code">
        <el-input
          placeholder="请输入验证码"
          clearable
          v-model="changePwdForm.sms_code"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
          placeholder="请输入密码"
          show-password
          clearable
          v-model="changePwdForm.password"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password2">
        <el-input
          placeholder="请输入密码"
          show-password
          clearable
          v-model="changePwdForm.password2"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="submit()"
    >
      提交
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { changePwd, sendSmsCode } from '@/servers/user.js';
import { mobileRegex } from '@/utils/reConsts.js';
import { showErrorMsg } from '@/utils/uiUtils.js';
import { setStorage } from '@/utils/storageUtils.js';

export default {
  data() {
    let validatePass = (_, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changePwdForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    let validateMobile = (_, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (!mobileRegex.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    return {
      count: 300,
      countInterval: 0,
      isSendSms: false,
      changePwdForm: {
        mobile: '',
        sms_code: '',
        password: '',
        password2: '',
      },
      changePwdRules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur',
          },
          {
            validator: validateMobile,
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
        password2: [
          {
            required: true,
            message: '请再次密码',
            trigger: 'blur',
          },
          {
            validator: validatePass,
            trigger: 'blur',
          },
        ],
        sms_code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
          {
            min: 6,
            max: 6,
            message: '请输入正确的验证码',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    ...mapMutations(['getUserState']),
    getCode: function() {
      let that = this;
      if (
        !this.changePwdForm.mobile ||
        !mobileRegex.test(this.changePwdForm.mobile)
      ) {
        showErrorMsg('请输入正确手机号码');
        return;
      }
      sendSmsCode({ mobile: this.changePwdForm.mobile }, function() {
        that.isSendSms = true;
        that.countInterval = setInterval(function() {
          that.count--;
          if (that.count < 1) {
            clearInterval(that.countInterval);
            that.isSendSms = false;
            that.count = 300;
          }
        }, 1000);
      });
    },

    submit: function() {
      let that = this;
      this.$refs.changePwdForm.validate((valid) => {
        if (valid) {
          changePwd(this.changePwdForm, function(res) {
            setStorage('token', res.token);
            setStorage('refreshToken', res.refresh_token);
            setStorage('tokenExpiredTime', res.token_expired_time);
            that.User.hasLogin = true;
            setTimeout(function() {
              that.getUserState();
            }, 1000);
            that.$router.replace({
              path: '/',
            });
          });
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>

<style scoped>
.login-button {
  width: 200px;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/changePwd/changePwd.vue